import { AISuggestion } from '@/api/ai-api';
import { Button } from '@/components/ui/Button';

interface AISuggestionCardProps {
  suggestion: AISuggestion;
  onReview: (suggestionId: string, accepted: boolean) => void;
  isLoading?: boolean;
}

export function AISuggestionCard({ suggestion, onReview, isLoading }: AISuggestionCardProps) {
  return (
    <div className={`bg-white rounded-lg border p-4 ${
      suggestion.accepted === true ? 'border-green-300 bg-green-50' :
      suggestion.accepted === false ? 'border-red-300 bg-red-50' :
      'border-gray-200'
    }`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold uppercase text-gray-500">
          {suggestion.type.replace(/_/g, ' ')}
        </span>
        {suggestion.confidence && (
          <span className="text-xs text-gray-400">
            Confiança: {(suggestion.confidence * 100).toFixed(0)}%
          </span>
        )}
      </div>

      <pre className="text-sm text-gray-700 whitespace-pre-wrap font-sans mb-3">
        {JSON.stringify(suggestion.content, null, 2)}
      </pre>

      {suggestion.accepted === null && (
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onReview(suggestion.id, true)}
            disabled={isLoading}
            className="text-green-600 border-green-300 hover:bg-green-50"
          >
            Aceitar
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onReview(suggestion.id, false)}
            disabled={isLoading}
            className="text-red-600 border-red-300 hover:bg-red-50"
          >
            Rejeitar
          </Button>
        </div>
      )}

      {suggestion.accepted !== null && (
        <span className={`text-xs font-medium ${
          suggestion.accepted ? 'text-green-600' : 'text-red-600'
        }`}>
          {suggestion.accepted ? 'Aceita pelo médico' : 'Rejeitada pelo médico'}
        </span>
      )}
    </div>
  );
}
